import { render, staticRenderFns } from "./VehiclesBehaviorRightSidebar.vue?vue&type=template&id=c2d3423e&scoped=true&"
import script from "./VehiclesBehaviorRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./VehiclesBehaviorRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesBehaviorRightSidebar.vue?vue&type=style&index=0&id=c2d3423e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d3423e",
  null
  
)

export default component.exports